export default __webpack_public_path__ + "static/media/pma_token_card.139762e8.png";